import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="ba-seccion" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-itinerario" />
        <Reveal>
          <ul className="ba-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="ba-itinerario-item" key={i} data-testid={`ba-itinerario-item-${i}`}>
                  <p className="ba-itinerario-hora">
                    <Icono size={14} strokeWidth={1.5} />
                    {item.hora}
                  </p>
                  <h3 className="ba-itinerario-titulo">{item.titulo}</h3>
                  {item.descripcion && <p className="ba-itinerario-desc">{item.descripcion}</p>}
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
